attachEvent('.menu__arrow', 'click', (arrow) => {
  const parent = arrow.target.closest('.menu__item');
  parent.classList.toggle('is-open');

  const dropdown = parent.querySelector('.menu__dropdown');
  slideToggle(dropdown, 300, 'block');
});
